// extracted by mini-css-extract-plugin
export var image = "p_d";
export var link = "p_bs";
export var logo = "p_bn";
export var scrolled = "p_y";